const verification = () => {
    return ( 
        <div className="SpecificBlog">
            <div>
            <h3>Please check the email address that you provided for verification</h3>
            </div>
        </div>
     );
}
 
export default verification;